import { render, staticRenderFns } from "./filters_list.vue?vue&type=template&id=39d0a191&"
import script from "./filters_list.vue?vue&type=script&lang=js&"
export * from "./filters_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports